import { Component, Input } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { PromptBlock } from '../prompt-block/prompt-block';
import { defaultPrompts } from '@eda/features/messenger/messenger.config';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'aiops-prompts-dialog',
  imports: [DialogModule, PromptBlock, TranslatePipe],
  templateUrl: './prompts-dialog.html'
})
export class PromptsDialog {
  @Input() prompts = defaultPrompts

  visible: boolean = false;

  showDialog() {
    this.visible = true;
  }

  closeDialog() {
    this.visible = false;
  }
}
